function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Icons/Homeewf");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Sidebar/-1820",
  transform: "translate(-47.000000, -182.000000)",
  fill: "#30A3FF",
  stroke: "#30A3FF",
  strokeWidth: 0.1
}, React.createElement("g", {
  id: "nav",
  transform: "translate(4.000000, 0.000000)"
}, React.createElement("g", {
  id: "Discover",
  transform: "translate(20.000000, 134.000000)"
}, React.createElement("g", {
  id: "Home",
  transform: "translate(0.000000, 38.000000)"
}, React.createElement("g", {
  id: "Icons/Home-blue",
  transform: "translate(24.000000, 11.000000)"
}, React.createElement("path", {
  d: "M13.2391729,14.6909018 L10.8813729,14.6909018 L10.8813729,9.50105459 C10.8813729,9.13959803 10.5882843,8.84650548 10.2268325,8.84650548 L5.77304883,8.84650548 C5.41159708,8.84650548 5.11850844,9.13959803 5.11850844,9.50105459 L5.11850844,14.6909018 L2.76943571,14.6909018 L2.76943571,6.05158077 L7.99994068,1.51773726 L13.2391729,6.05885354 L13.2391729,14.6909018 Z M15.774426,6.52358341 L8.42684647,0.154820553 C8.42684647,0.154820553 8.42102833,0.159184213 8.41884653,0.160638767 C8.17666658,-0.0451805649 7.82030571,-0.0597261007 7.57303489,0.154820553 L0.225455405,6.52358341 C-0.0472697563,6.76067565 -0.0770877073,7.17449614 0.160728634,7.44722494 C0.298909382,7.60722583 0.496726033,7.68286262 0.692360882,7.67195347 C0.831996165,7.66395342 0.970176913,7.61158949 1.08363058,7.51267985 L1.4589004,7.18758712 L1.4589004,14.6894472 C1.4589004,15.4101785 2.04798675,16 2.76943571,16 L5.11850844,16 C5.84141193,16 6.42758921,15.4138149 6.42758921,14.6909018 L6.42758921,10.1556037 L9.57229214,10.1556037 L9.57229214,14.6909018 C9.57229214,15.4138149 10.1584694,16 10.8813729,16 L13.2406274,16 C13.9635309,16 14.5497082,15.4138149 14.5497082,14.6909018 L14.5497082,7.19413261 L14.916978,7.51267985 C15.0297044,7.61158949 15.1678852,7.66395342 15.3075205,7.67195347 C15.5031553,7.68286262 15.7016992,7.60722583 15.83988,7.44722494 C16.0769691,7.17449614 16.0471511,6.76067565 15.774426,6.52358341 L15.774426,6.52358341 Z",
  id: "Fill-35"
})))))));

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.ef80de3e.svg";
export { ForwardRef as ReactComponent };